<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="offset-4 col-4 col-md-4 col-sm-4 col-xs-4 text-center">
        <button class="btn btn-danger" @click="closeMap">Close Map</button>
      </div>
    </div>
    <br>
    <div class="row col-12" id="map"></div>
    <br><br>
    <div class="row">
      <div class="offset-4 col-4 col-md-4 col-sm-4 col-xs-4 text-center">
        <button class="btn btn-danger" @click="closeMap">Close Map</button>
      </div>
    </div>
  </div>

</template>

<script>



export default {
  name: "MapModal",
  mounted() {
    //console.log("map mounted")
    this.drawMap()

  },
  watch: {
    lat: {
      deep: true,
      handler() {
        //console.log("lat changed")
        this.drawMap()
      }
    }
  },
  props: {
    lat: {
      type: Number,
      required: true,
    },
    lon: {
      type: Number,
      required: true,
    },
    displayName: {
      type: String,
      required: true,
    },
    verLat: {
      type: Number,
      required: true,
    },
    verLon: {
      type: Number,
      required: true,
    },
    verDisplayName: {
      type: String,
      required: true,
    },
  },
  emits: ["closemap"],
  methods: {
    closeMap() {
      this.$emit("closemap")
    },
    drawMap() {
      let stadium = new L.LatLng(this.lat, this.lon);
      let map = L.map('map',{
        // center:stadium,
        // zoom: 15
      }).setView({lon: this.lon, lat: this.lat}, 5);

      // add the OpenStreetMap tiles
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a> &copy; <a href="https://www.mapbox.com/">MapBox</a>',
        // center: [this.lat, this.lon],
        // zoom: 12,
      }).addTo(map);

      // L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
      //   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      //   maxZoom: 18,
      //   id: 'mapbox/streets-v11',
      //   tileSize: 512,
      //   zoomOffset: -1,
      //   center: [this.lat, this.lon],
      //   accessToken: 'pk.eyJ1IjoibWNsb3ZpczE5NTkiLCJhIjoiY2ttZmhwaWltMHpzcjJ2cDI2OTIyMXR5eCJ9.F9YQyjkfpucNbSYfScmTuw'
      // }).addTo(map);

      // show the scale bar on the lower left corner
      L.control.scale().addTo(map);


      const markerIcon = L.icon({
        iconSize: [25, 41],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40],
        // specify the path here
        iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
        shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
      });

      // show a marker on the map
      let marker = L.marker({lon: this.lon, lat: this.lat}).setIcon(markerIcon)
      marker.addTo(map)
          .bindPopup("Address: " + this.displayName)
          .openPopup();



      //
      //marker.bindPopup("Address: " + this.displayName).addTo(map);

      //L.marker(stadium, {icon: new L.Icon.Default() }).addTo(map);

      if (this.verLat !== 0) {
        let iconOptions = {
          iconUrl: 'redMarker.png',
          iconAnchor: [12, 41]

        }
        let customIcon = L.icon(iconOptions)

        let markerOptions = {
          title: "Verified Location",
          clickable: true,
          draggable: true,
          icon: customIcon
        }


        let verMarker = L.marker({lon: this.verLon, lat: this.verLat}, markerOptions)
        verMarker.bindPopup("Verified: " + this.verDisplayName).addTo(map);
      }
      let latLngs = [marker.getLatLng()];
      let markerBounds = L.latLngBounds(latLngs);
      map.fitBounds(markerBounds);
      map.panTo(marker.getLatLng())
    },
  },
}
</script>

<style scoped>
@media(min-width:0px){
  #map{
    width: 570px;
    height: 400px;
  }
}
@media (min-width: 576px){
  #map{
    width: 570px;
    height:400px;
  }
}
@media (min-width: 768px){
  #map{
    width: 760px;
    height:400px;
  }
}

@media (min-width: 992px){
  #map{
    width: 990px;
    height: 400px;
  }
}
@media (min-width: 1200px){
  #map{
    width:1190px;
    height: 400px;
  }
}



</style>
